import type { ReactNode } from 'react';

interface ReceiptDetailRowProps {
  label: string;
  value: ReactNode;
  mono?: boolean;
}

export function ReceiptDetailRow({ label, value, mono = false }: ReceiptDetailRowProps) {
  return (
    <div className="flex flex-col gap-0.5 border-b border-gray-200 py-2 last:border-b-0 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
      <span className="shrink-0 text-xs font-medium text-gray-600">{label}</span>
      <span
        className={`break-all text-xs text-gray-900 sm:max-w-[65%] sm:text-right ${
          mono ? 'font-mono' : 'font-medium'
        }`}
      >
        {value}
      </span>
    </div>
  );
}
